import { formatCurrency, formatCurrencyWithName } from './constants';
import { resolveSaleReceiptDate } from './saleReceiptDateTime';

export function getReceiptFormatLocale(language = 'fr') {
  return language === 'ar' ? 'ar-MR' : 'fr-MR';
}

export function formatReceiptAmountOnly(amount, language = 'fr') {
  const formatted = formatCurrency(amount, getReceiptFormatLocale(language));
  return formatted.replace(/\s+(MRO|MRU)$/i, '').trim();
}

/**
 * Plain-text currency for messages (confirm dialogs, etc.).
 * Same reading order as POS UI: amount then currency (Arabic: currency after number).
 */
export function formatReceiptCurrencyText(amount, language = 'fr', getCurrencyName) {
  const label = getCurrencyName(language);
  const value = formatReceiptAmountOnly(amount, language);
  if (language === 'ar') {
    return `\u2067${value}\u00A0${label}\u2069`;
  }
  return `${value} ${label}`;
}

/** @deprecated Use formatReceiptCurrencyText for plain text */
export function formatReceiptCurrency(amount, language = 'fr', getCurrencyName) {
  if (typeof getCurrencyName === 'function') {
    return formatReceiptCurrencyText(amount, language, getCurrencyName);
  }
  return formatCurrency(amount, getReceiptFormatLocale(language));
}

export function formatReceiptCurrencyWithName(amount, language = 'fr', currencyName) {
  return formatCurrencyWithName(amount, getReceiptFormatLocale(language), currencyName);
}

/** Trennt Kundenname vs. Handynummer während der Eingabe (nur Ziffern/+/-). */
export function splitReceiptCustomerInput(input = '') {
  const trimmed = String(input || '').trim();
  if (!trimmed) return { customerName: '', customerPhone: '' };
  if (/^[\d\s+\-()+]+$/.test(trimmed)) {
    return { customerName: '', customerPhone: trimmed };
  }
  return { customerName: trimmed, customerPhone: '' };
}

export function normalizePhoneDigits(phone = '') {
  return String(phone || '').replace(/[\s\-()]/g, '');
}

export function phonesMatch(a, b) {
  const left = normalizePhoneDigits(a);
  const right = normalizePhoneDigits(b);
  return Boolean(left && right && left === right);
}

export function buildReceiptPrintPayload(saleData, extras = {}) {
  const {
    businessInfo,
    businessData,
    customerInput = '',
    customerPhone
  } = extras;

  const split = splitReceiptCustomerInput(customerInput);
  const resolvedName = split.customerName || saleData?.customerName || '';
  const resolvedPhone =
    customerPhone ?? split.customerPhone ?? saleData?.customerPhone ?? '';

  return {
    businessInfo: businessData || businessInfo || {},
    customerName: resolvedName,
    customerPhone: resolvedPhone,
    date: resolveSaleReceiptDate(saleData, {
      useLiveTime: saleData?.status === 'pending'
    }),
    location: saleData?.location || 'Magasin',
    workerName: saleData?.workerName || 'Vendeur',
    products: saleData?.products || [],
    subtotal: saleData?.subtotal || 0,
    discount: saleData?.discount || 0,
    tax: saleData?.tax || 0,
    total: saleData?.total || 0,
    paymentMethod: saleData?.paymentMethod || 'cash',
    cashAmount: saleData?.cashAmount || 0,
    change: saleData?.change || 0,
    electronicPaymentMethod: saleData?.electronicPaymentMethod || '',
    notes: saleData?.notes || '',
    orderId: saleData?.orderId || saleData?.previewOrderId || null
  };
}
